/// <amd-module name="Release/DeletedPipelines/Actions" />

import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { IDeletedDefinitionReference } from "./DeletedPipelinesData";

export interface IDeletedPipelinesListPayload {
    pipelines: IDeletedDefinitionReference[];
    isLoading: boolean;
}

export class Actions extends ActionsHubBase {
    public static getKey(): string {
        return "rm-del-pipelines-actions";
    }

    public initialize(): void {
    }

    public get fetchDeletedPipelines(): Action<IDeletedPipelinesListPayload> {
        return this._fetchDeletedPipelines;
    }

    public get selectPipeline(): Action<IDeletedDefinitionReference> {
        return this._selectPipeline;
    }

    public get handleUndelete(): Action<number> {
        return this._handleUndelete;
    }

    private _fetchDeletedPipelines: Action<IDeletedPipelinesListPayload> = new Action<IDeletedPipelinesListPayload>();
    private _selectPipeline: Action<IDeletedDefinitionReference> = new Action<IDeletedDefinitionReference>();
    private _handleUndelete: Action<number> = new Action<number>();
}
